(function() { window.GUID_8dff49ff_d451_4fbb_af23_fdc9fda9fd7d = { getGuid: function() { return "8dff49ff-d451-4fbb-af23-fdc9fda9fd7d"; } }; })();
//namespace CS.Controls {
//    export module PersonaPicture {
//        //const will be render in JS, type is used for reference(Ts only)
//        export const PersonaType = CS.Enumeration.PersonaType;
//        export type PersonaType = CS.Enumeration.PersonaType;
//        export const PictureSize = CS.Enumeration.PictureSize;
//        export type PictureSize = CS.Enumeration.PictureSize;
//        export function SetupImageClasses(image: JQuery, personaType: PersonaType, pictureSize: PictureSize) {
//            var div = image.closest(".persona-picture");
//            if (div.length == 0) {
//                //No div wrapper. So we create it and move the image inside it
//                div = $('<div></div>');
//                var inner = $('<div></div>');
//                inner.addClass('inner');
//                div.append(inner);
//                div.insertAfter(image);
//                image.appendTo(inner);
//            }
//            else
//                div.removeAttr('class');
//            div.addClass("persona-picture");
//            switch (personaType) {
//                case PersonaType.Player:
//                    div.addClass("player");
//                    break;
//                case PersonaType.Team:
//                    div.addClass("team");
//                    break;
//                case PersonaType.User:
//                    div.addClass("user");
//                    break;
//                default:
//            }
//            switch (pictureSize) {
//                case PictureSize.Large:
//                    div.addClass("large");
//                    break;
//                case PictureSize.Medium:
//                    div.addClass("medium");
//                    break;
//                case PersonaPicture.PictureSize.Small:
//                    div.addClass("small");
//                    break;
//            }
//        }
//    }
//}

//# sourceMappingURL=PersonaHelper.js.map
